module.exports = __webpack_public_path__ + "img/art4-img1.11f60e4b.jpeg";